import service from './request'

export const getUser = data => {
  return service({
    url: '/addons/shopro/user',
    method: 'get',
    params: data
  })
};

export const getUserData = data => {
  return service({
    url: '/addons/shopro/user/userData',
    method: 'get',
    params: data
  })
};

export const getCategoryDetail = data => {
  return service({
    url: '/addons/shopro/category/detail',
    method: 'get',
    params: data
  })
};
export const userlogout = data => {
  return service({
    url: '/addons/shopro/user/logout',
    method: 'POST',
    data
  })
};


export const getCategoryIndex = data => {
  return service({
    url: '/addons/shopro/category/index',
    method: 'get',
    params: data,
  })
};

export const getTemplate = data => {
  return service({
    url: '/addons/shopro/index/template?shop_id=0',
    method: 'get',
    params: data,
  })
};

export const getGoodsList = data => {
  return service({
    url: '/addons/shopro/goods/lists',
    method: 'get',
    params: data,
  })
};


export const getGoodsDetail = data => {
  return service({
    url: '/addons/shopro/goods/detail',
    method: 'get',
    params: data,
  })
};

export const getSeckillList = data => {
  return service({
    url: '/addons/shopro/goods/seckillList',
    method: 'get',
    params: data,
  })
};

export const getCartIndex = data => {
  return service({
    url: '/addons/shopro/cart/index',
    method: 'get',
    params: data,
  })
};


export const getArticleIndex = data => {
  return service({
    url: '/addons/shopro/article/index',
    method: 'get',
    params: data,
  })
};

export const getArticleDetail = data => {
  return service({
    url: '/addons/shopro/article/new_detail',
    method: 'get',
    params: data,
  })
};

export const getUserAgreement = data => {
  return service({
    url: '/api/verify_account/getUserAgreement',
    method: 'get',
    params: data,
  })
};



export const getRichtext = data => {
  return service({
    url: '/addons/shopro/index/richtext',
    method: 'get',
    params: data,
  })
};

export const getofflineInfo = data => {
  return service({
    url: '/addons/shopro/pay/offlineInfo',
    method: 'get',
    params: data,
  })
};




export const getOrderDetail = data => {
  return service({
    url: '/addons/shopro/order/detail',
    method: 'get',
    params: data,
  })
};



export const getCartAdd = data => {
  return service({
    url: '/addons/shopro/cart/add',
    method: 'POST',
    data
  })
};


export const getCartEdit = data => {
  return service({
    url: '/addons/shopro/cart/edit',
    method: 'POST',
    data
  })
};



// WEBPACK FOOTER //
// ./src/axios/index.js